export const MVD_TICKET_STATUS = {
	IDLE: 'idle',
	LOADING: 'loading',
	SUCCESS: 'success',
	PARTIAL: 'partial',
	ERROR: 'error',
};

export const MVD_API_RESULT_STATUS = {
	FAILURE: 'FAILURE',
};
